import React, {useState} from 'react';
import utils from "../lib/utils";
import {Avatar as MuiAvatar, SxProps} from "@mui/material";

interface AvatarProps {
    user: { username: string, avatar: string },
    size?: number,
    sx?: SxProps,
}

const Avatar = ({user, sx, size = 30}: AvatarProps) => {
    //@todo  avatar failed back up
    const avatar_url = utils.createAvatarUrl(user?.['avatar'], size)
    const [avatarUrl, setAvatarUrl] = useState(avatar_url);

    const sizeStr = `${size}px`;

    return <MuiAvatar
            alt={user?.username}
            src={avatar_url}
            sx={{
                width: sizeStr,
                height: sizeStr,
                ...sx
            }}
    />

    // return <img
    //         crossOrigin="anonymous"
    //         style={{
    //             minWidth: sizeStr,
    //             minHeight: sizeStr,
    //             width: sizeStr,
    //             height: sizeStr,
    //             borderRadius: "15px",
    //             marginRight: "10px",
    //         }}
    //         src={avatar_url}
    //         alt={''}
    //         onError={() => {
    //             if (!avatarUrl) {
    //                 setAvatarUrl(utils.createAvatarUrl())
    //             }
    //
    //         }}
    // />
};

export default Avatar;
